import * as React from 'react'
import { connect } from 'react-redux'
import { get } from 'lodash'
import { getAllCallUsage } from 'features/Numbers/Numbers.actions'
import { CallsVolumeAllServices } from './CallsVolumeAllServices'
import { getDateInterval, getCallsForPeriod } from '../../utils'
import * as sMarg from 'styles/modules/margins.scss'

const stateToProps = ({ numbers }) => {
  const callUsage = get(numbers, ['callUsage', 'all'], {})
  return {
    callUsage,
  }
}

const dispatchToProps = {
  getAllCallUsage,
}

export interface ICallsVolumeAllServicesContainerProps {
  numberId: string
}

class CallsVolumeAllServicesComponent extends React.Component<any> {
  componentDidMount() {
    const { getAllCallUsage } = this.props
    getAllCallUsage()
  }
  render() {
    const { callUsage } = this.props
    const periodValue = 28
    const periodUnit = 'day'
    const sumPeriod = 'day'
    const dateInterval = getDateInterval({ periodValue, periodUnit, sumPeriod })
    const { calls } = getCallsForPeriod({ callsRaw: callUsage.data, periodValue, periodUnit })
    return (
      <CallsVolumeAllServices
        calls={calls}
        loading={callUsage.loading}
        dateInterval={dateInterval}
        sumPeriod={sumPeriod}
        dateFormat="D MMM"
        height={350}
        className={sMarg.mb30}
      />
    )
  }
}

export const CallsVolumeAllServicesContainer = connect(
  stateToProps,
  dispatchToProps
)(CallsVolumeAllServicesComponent) as React.SFC<ICallsVolumeAllServicesContainerProps>



// WEBPACK FOOTER //
// src/features/CallAnalytics/Cards/CallsVolumeAllServices/CallsVolumeAllServices.container.tsx